import api from '@/plugins/request/index';

// 获取业务设置新客池
export const getSystemNewPool = async (type = 'get') => {
  return api[type](`/gateway/v1/company/business-setting/new-pool`).then(res => res);
}
// 业务设置新客池
export const setSystemNewPool = async (params, type = 'put') => {
  return api[type](`/gateway/v1/company/business-setting/new-pool`, params).then(res => res);
}
// 获取业务设置公客池
export const getSystemPublicPool = async (type = 'get') => {
  return api[type](`/gateway/v1/company/business-setting/public-pool`).then(res => res);
}
// 业务设置公客池
export const setSystemPublicPool = async (params, type = 'put') => {
  return api[type](`/gateway/v1/company/business-setting/public-pool`, params).then(res => res);
}
// 获取业务设置客户上限
export const getSystemCustomeLimit = async (type = 'get') => {
  return api[type](`/gateway/v1/company/business-setting/customer-limit`).then(res => res);
}
// 业务设置客户上限
export const setSystemCustomeLimit = async (params, type = 'put') => {
  return api[type](`/gateway/v1/company/business-setting/customer-limit`, params).then(res => res);
}
// 获取业务设置客户跟进
export const getSystemCustomeFollow = async (type = 'get') => {
  return api[type](`/gateway/v1/company/business-setting/customer-follow`).then(res => res);
}
// 业务设置客户跟进
export const setSystemCustomeFollow = async (params, type = 'put') => {
  return api[type](`/gateway/v1/company/business-setting/customer-follow`, params).then(res => res);
}
// 获取业务设置客户等级
export const getSystemCustomeLevel = async (type = 'get') => {
  return api[type](`/gateway/v1/company/business-setting/customer-level`).then(res => res);
}
// 业务设置客户等级
export const setSystemCustomeLevel = async (params, type = 'put') => {
  return api[type](`/gateway/v1/company/business-setting/customer-level`, params).then(res => res);
}
// 获取业务设置待办任务
export const getSystemTask = async (type = 'get') => {
  return api[type](`/gateway/v1/company/business-setting/task`).then(res => res);
}
// 业务设置待办任务
export const setSystemTask = async (params, type = 'put') => {
  return api[type](`/gateway/v1/company/business-setting/task`, params).then(res => res);
}



// 获取审批流程配置列表
export const getApproveConfig = async (type = 'get') => {
  return api[type](`/gateway/v1/approval/setting/list`).then(res => res);
}
// 开启审批配置流程
export const setApproveEnable = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/setting/${id}/enable`, params).then(res => res);
}
// 关闭审批配置流程
export const setApproveDisable = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/setting/${id}/disable`, params).then(res => res);
}
// 获取审批流程列表
export const getApproveDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/setting/${id}/flow`, params).then(res => res);
}
// 获取当前登录用户权限下级部门列表
export const getUserChildrenDepart = async (type = 'get') => {
  return api[type](`/gateway/v1/dept/list-by-admin`).then(res => res);
}
// 获取当前登录权限下的审批人员列表
export const getUserApproveList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/dept/list-by-voucher`, params).then(res => res);
}
// 搜索有权限的人员(带部门)
export const getUserDepartList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/admin/search-name-with-detp`, params).then(res => res);
}
// 设置审批流程
export const setApproveProcess = async (id, params, type = 'post') => {
  return api[type](`/gateway/v1/approval/setting/${id}/flow`, params).then(res => res);
}
// 设置企业报备流程设置
export const setCompanyReportProcess = async (params, type = 'put') => {
  return api[type](`/gateway/v1/company/setting-process`, params).then(res => res);
}
// 获取业务设置
export const getBussinessSetting = async (type = 'get') => {
  return api[type](`/gateway/v1/company/business-setting`).then(res => res);
}
// 设置业务配置
export const setBussinessSetting = async (params, type = 'put') => {
  return api[type](`/gateway/v1/company/business-setting`, params).then(res => res);
}
// 公客池获取平台来源
export const getPublicPoolPlatform = async (type = 'get') => {
  return api[type](`/gateway/v1/company/business-setting/public-pool/platform-source`).then(res => res);
}
// 添加单个跟进规则
export const setFollowRule = async (params, type = 'post') => {
  return api[type](`/gateway/v1/task/task-config/save`, params).then(res => res);
}
// 删除单个跟进规则
export const removeFollowRule = async (params, type = 'delete') => {
  return api[type](`/gateway/v1/task/task-config`, params).then(res => res);
}
// 刷新真个跟进规则
export const getFollowRuleBatch = async (params, type = 'get') => {
  return api[type](`/gateway/v1/task/task-config/batch`, params).then(res => res);
}
// 获取商户代理状态
export const getCompanyAgentStatus = async (type = 'get') => {
  return api[type](`/gateway/v1/company/agent-status`).then(res => res);
}
// 获取套餐列表
export const getCombos = async (params, type = 'get') => {
  return api[type](`/gateway/v1/sets`, params).then(res => res);
}
// 获取单个套餐详情
export const getCombosDetail = async (id, type = 'get') => {
  return api[type](`/gateway/v1/sets/${id}/admins`).then(res => res);
}
// 获取套餐数量
export const getCombosCount = async (id, type = 'get') => {
  return api[type](`/gateway/v1/sets/count`).then(res => res);
}
// 批量添加经纪人套餐
export const addCombos = async (id, params, type = 'post') => {
  return api[type](`/gateway/v1/sets/${id}/admins`, params).then(res => res);
}
// 获取新房卡总数
export const getCardCustomes = async (type = 'get') => {
  return api[type](`/gateway/v1/sets/gained-customer-count`).then(res => res);
}
// 获取新房卡已获客详情
export const getCardGainedCustome = async (params, type = 'get') => {
  return api[type](`/gateway/v1/sets/gained-customers`, params).then(res => res);
}
// 获取绑定楼盘数
export const getCardBindHouse = async (type = 'get') => {
  return api[type](`/gateway/v1/sets/bind-houses-num`).then(res => res);
}
// 删除经纪人套餐分配
export const deleteCardCustuome = async (id, type = 'delete') => {
  return api[type](`gateway/v1/sets/admin-detail/${id}`).then(res => res);
}
// 修改经纪人套餐分配
export const editCardCustuome = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/sets/admin-detail/${id}`, params).then(res => res);
}
// 获取销售助手详情
export const getSaleHelperDetail = async (type = 'get') => {
  return api[type](`/gateway/v1/sale-helper/setting`).then(res => res);
}
// 打开销售助手
export const openSaleHelper = async (type = 'post') => {
  return api[type](`/gateway/v1/sale-helper/setting/open`).then(res => res);
}
// 编辑销售助手系统智能管理
export const setSaleHelpSystem = async (params, type = 'put') => {
  return api[type](`/gateway/v1/sale-helper/setting/set`, params).then(res => res);
}
// 编辑销售助手经纪人行为智能管控
export const setSaleHelpAdmin = async (params, type = 'put') => {
  return api[type](`/gateway/v1/sale-helper/setting/set-admin`, params).then(res => res);
}
// 编辑销售助手客户信息管控
export const setSaleHelpCustome = async (params, type = 'put') => {
  return api[type](`/gateway/v1/sale-helper/setting/set-customer`, params).then(res => res);
}
// 操作日志列表
export const getActionLog = async (params, type='get') => {
  return api[type](`/gateway/v1/log/action-log`, params).then(res => res);
}
// 全部动作
export const getActionsAll = async (params, type = 'get') => {
  return api[type]('/gateway/v1/log/action-log/actions-all', params).then(res => res);
}
// 全部对象
export const getModuleAll = async (params, type = 'get') => {
  return api[type]('/gateway/v1/log/action-log/module-all', params).then(res => res);
}
// 全部终端
export const getTerminallAll = async (params, type = 'get') => {
  return api[type]('/gateway/v1/log/action-log/terminall-all', params).then(res => res);
}
